// Persistent banner shown across the app while an admin is impersonating a
// member. Polls the console state on mount; renders nothing unless an
// impersonation is active. "Exit" restores the admin identity and returns to
// the admin console.
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { either } from '../lib/utils/utils';
import { postAdminSession, postAdminExitImpersonation } from './adminApi';
import { ADMIN_PATH } from './adminPath';

const ImpersonationBanner = ({ history, location }) => {
	const [state, setState] = useState(null);

	const refresh = () =>
		postAdminSession().then(
			either(
				() => setState(null),
				s => setState(s || null)
			)
		);

	// Re-check on every navigation: impersonation starts via an SPA push (no
	// remount), so a mount-only check would miss it and never show the banner.
	useEffect(() => {
		refresh();
	}, [location && location.pathname]);

	if (!state || !state.impersonating) return null;

	const who =
		state.currentUser &&
		`${state.currentUser.firstName || ''} ${state.currentUser.lastName ||
			''}`.trim();

	const exit = () =>
		postAdminExitImpersonation().then(
			either(
				() => refresh(),
				() => {
					setState(null);
					history.push(ADMIN_PATH);
				}
			)
		);

	return (
		<Box
			sx={{
				bgcolor: 'warning.main',
				color: 'warning.contrastText',
				px: 2,
				py: 1,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				gap: 2,
				fontWeight: 600
			}}>
			<span>
				Viewing as {who || 'member'}
				{state.currentUser ? ` (#${state.currentUser.memberID})` : ''} —
				impersonated by {state.impersonatedBy}
			</span>
			<Button
				size="small"
				variant="contained"
				color="inherit"
				onClick={exit}>
				Exit impersonation
			</Button>
		</Box>
	);
};

export default withRouter(ImpersonationBanner);
